package org.multiplatform.kotfolio.sections

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.Logo
import org.multiplatform.kotfolio.components.socialBar
import org.multiplatform.kotfolio.models.Section
import org.multiplatform.kotfolio.util.Constants.FONT_FAMILY
import org.multiplatform.kotfolio.util.Constants.SECTION_WIDTH
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.multiplatform.kotfolio.rememberAppState

@Composable
fun footerSection() {
    val breakpoint = rememberAppState().breakpoint

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(Color.rgb(10, 5, 0)) // Deeper dark
            .styleModifier {
                property("border-top", "1px solid rgba(245, 158, 11, 0.15)")
            }
            .padding(
                top = if (breakpoint >= Breakpoint.MD) 100.px else 60.px,
                bottom = 40.px,
            ),
        contentAlignment = Alignment.Center,
    ) {
        Box(
            modifier = Modifier.fillMaxWidth().maxWidth(SECTION_WIDTH.px),
            contentAlignment = Alignment.Center,
        ) { footerContent(breakpoint) }
    }
}

@Composable
private fun footerContent(breakpoint: Breakpoint) {
    Column(
        modifier = Modifier.fillMaxWidth(
            if (breakpoint >= Breakpoint.MD) 100.percent else 90.percent,
        ),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Logo(
            modifier = Modifier.margin(bottom = 16.px),
        )

        // Version Pill
        Box(
            modifier = Modifier
                .margin(bottom = 40.px)
                .backgroundColor(Color.rgba(255, 255, 255, 0.03f))
                .padding(leftRight = 16.px, topBottom = 4.px)
                .borderRadius(50.px)
                .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, Color.rgba(255, 255, 255, 0.08f)),
        ) {
            Span(
                attrs = Modifier
                    .color(Color.rgba(255, 255, 255, 0.4f))
                    .fontSize(11.px)
                    .fontFamily(FONT_FAMILY)
                    .fontWeight(FontWeight.Bold)
                    .styleModifier { property("letter-spacing", "2px") }
                    .toAttrs(),
            ) { Text("VERSION ${org.multiplatform.kotfolio.util.Constants.VERSION}") }
        }

        if (breakpoint > Breakpoint.SM) {
            Row(
                modifier = Modifier.fillMaxWidth().margin(bottom = 48.px),
                horizontalArrangement = Arrangement.Center,
            ) { footerMenu() }
        } else {
            Column(
                modifier = Modifier.fillMaxWidth().margin(bottom = 48.px),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) { footerMenu(row = false) }
        }

        socialBar(row = true)

        // Copyright line
        Box(
            modifier = Modifier
                .margin(top = 80.px)
                .fillMaxWidth()
                .height(1.px)
                .backgroundColor(Color.rgba(255, 255, 255, 0.05f)),
        )

        Span(
            attrs = Modifier
                .margin(top = 40.px)
                .color(Color.rgba(255, 255, 255, 0.3f))
                .fontSize(14.px)
                .fontFamily(FONT_FAMILY)
                .toAttrs(),
        ) {
            Text("© 2026 multiplatformdeveloper. All rights reserved.")
        }
    }
}

@Composable
private fun footerMenu(row: Boolean = true) {
    Section.entries.toTypedArray().take(8).forEach { section ->
        Link(
            modifier = Modifier
                .fontSize(15.px)
                .fontFamily(FONT_FAMILY)
                .fontWeight(FontWeight.Medium)
                .padding(
                    leftRight = if (row) 20.px else 0.px,
                    bottom = if (row) 0.px else 24.px,
                )
                .color(Color.rgba(255, 255, 255, 0.6f))
                .textDecorationLine(TextDecorationLine.None)
                .styleModifier {
                    property("transition", "color 0.3s ease")
                    property("cursor", "pointer")
                }
                .onMouseEnter {
                    // Manual hover handling since we are using plain Link for more control
                }
                .styleModifier {
                    // We can use NavigationItemStyle or just custom hover
                },
            path = section.path,
            text = section.title,
        )
    }
}
